import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DokumentPortalowy } from '../../shared/models/dokument-portalowy.model';

@Injectable({
  providedIn: 'root',
})
export class DokumentPortalowyService {

  constructor(
    private http: HttpClient,
  ) { }

  getDokumenty(): Observable<DokumentPortalowy[]> {
    return this.http.get<DokumentPortalowy[]>('/api/dokument-klienta/portal');
  }

  pobierzPlik(id: number): Observable<Blob> {
    return this.http.get(`/api/dokument-klienta/portal/${id}/plik`, { responseType: 'blob' });
  }
}
